import {XauditModel} from "../../../../models/xaudit.model";

export class ReferralAttachmentModel extends XauditModel {
  ReferralAttchID: string;
  ReferralID: string;
  Description: string;
  DocumentID: string;
}
